export default __webpack_public_path__ + "static/media/bannerMateri2.fa135791.jpg";